import React from "react";
import { object, func, oneOf, bool, string, array } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import { getSlug } from "../../utils/utils";
import Loadericon from "../load-more-button-loader/index";

import "./more.m.css";

const More = ({ collection, type, onClick, text, sections, showButtonSpinner = false, domainSlug }) => {
  if (type === "read-more") {
    const slug = getSlug(collection, sections, domainSlug);

    return (
      <Link aria-label={text} href={slug} styleName="wrapper" className="more">
        <span styleName="content" className="content">
          {text}
        </span>
      </Link>
    );
  } else {
    return (
      <div styleName="wrapper" className="more" onClick={onClick}>
        <span styleName="content" className="load-more-content">
          {text}
          {showButtonSpinner && <Loadericon />}
        </span>
      </div>
    );
  }
};

More.defaultProps = {
  type: "read-more",
  text: "Read More",
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

More.propTypes = {
  sections: array,
  text: string,
  collection: object,
  onClick: func,
  type: oneOf(["read-more", "load-more"]),
  showButtonSpinner: bool,
  domainSlug: string,
};

export default connect(mapStateToProps)(More);
